import { UrlActionTypes } from './url.types';
import {
  formUrlObject,
  setIsReviewedStatus,
  setIsIgnoredStatus,
  filterIgnoredUrls,
  formatStatusTableData,
  updateRevisedCategory
} from './url.utils';

const INITIAL_STATE = {
  unPublishedUrls: null,
  filteredUrls: null,
  publishNotificationSummary: null,
  publushSummary: null
};

const urlReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UrlActionTypes.SET_UNPUBLISHED_URLS:
      return {
        ...state,
        unPublishedUrls: formUrlObject(action.payload)
      };
    case UrlActionTypes.SET_FILTERED_URLS:
      return {
        ...state,
        filteredUrls: action.payload
      };
    case UrlActionTypes.SET_URL_AS_REVIEWED:
      return {
        ...state,
        unPublishedUrls: setIsReviewedStatus(action.payload)
      };
    case UrlActionTypes.SET_URL_AS_IGNORED:
      return {
        ...state,
        unPublishedUrls: setIsIgnoredStatus(action.payload)
      };
    case UrlActionTypes.SET_FILTERED_URL_AS_REVIEWED:
      return {
        ...state,
        filteredUrls: setIsReviewedStatus(action.payload)
      };
    case UrlActionTypes.SET_FILTERED_URL_AS_IGNORED:
      return {
        ...state,
        filteredUrls: setIsIgnoredStatus(action.payload)
      };
    case UrlActionTypes.REMOVE_IGNORED_URLS:
      return {
        ...state,
        filteredUrls: filterIgnoredUrls(action.payload),
        unPublishedUrls: filterIgnoredUrls(action.payload)
      };
    case UrlActionTypes.SET_REVISED_CATEGORY:
      return {
        ...state,
        unPublishedUrls: updateRevisedCategory(action.payload)
      };
    case UrlActionTypes.SET_FILTERED_URL_REVISED_CAT:
      return {
        ...state,
        filteredUrls: updateRevisedCategory(action.payload)
      };
    case UrlActionTypes.SET_PUBLISH_NOTIFICATION_SUMMARY:
      return {
        ...state,
        publishNotificationSummary: action.payload
      };
    case UrlActionTypes.SET_PUBLISH_SUMMARY:
      return {
        ...state,
        publushSummary: formatStatusTableData(action.payload)
      };
    default:
      return state;
  };
};

export default urlReducer;